module.exports = __webpack_public_path__ + "img/icon-good.ef6a8dcf.png";